/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddPurchaseOrderDto as DigiworkMaitreDPosDtoPurchesOrdersAddPurchaseOrderDto } from '../../models/Digiwork/MaitreD/Pos/DTO/PurchesOrders/add-purchase-order-dto';
import { PurchaseOrderDto as DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto } from '../../models/Digiwork/MaitreD/Pos/DTO/PurchesOrders/purchase-order-dto';

export interface AddPurchaseOrder$Params {
  inventoryId: string;
      body?: DigiworkMaitreDPosDtoPurchesOrdersAddPurchaseOrderDto
}

export function addPurchaseOrder(http: HttpClient, rootUrl: string, params: AddPurchaseOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto>> {
  const rb = new RequestBuilder(rootUrl, addPurchaseOrder.PATH, 'post');
  if (params) {
    rb.path('inventoryId', params.inventoryId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto>;
    })
  );
}

addPurchaseOrder.PATH = '/api/inventories/{inventoryId}/purchase-orders';
